import { FC } from "react"
import classNames from "classnames"
import { Wearable } from "../types"
import { SearchAndSelect } from "@/components/SearchAndSelect"
import { Icon, IconColor } from "@/components/shared/Icon"
import { getBatteryChargeIcon } from "@/utils/index"
import "./index.scss"

interface WearableManualSelectionProps {
   wearables?: Wearable[]
   inmateId?: string
   isLoading?: boolean
   onCancel: () => void
   onSave: (wearableId: string) => void
}

const WearableManualSelection: FC<WearableManualSelectionProps> = ({
   wearables = [],
   inmateId,
   isLoading = false,
   onCancel,
   onSave,
}) => {
   const filterWearables = (wearable: Wearable, searchTerm: string) => {
      const searchValue = searchTerm.toLowerCase()
      return (
         wearable.id.toLowerCase().includes(searchValue) ||
         wearable.macAddress.toLowerCase().includes(searchValue)
      )
   }

   const renderWearable = (
      wearable: Wearable,
      isSelected: boolean,
      handleSelect: (wearable: Wearable) => void
   ) => (
      <div
         key={wearable.id}
         className={classNames("wearable-manual-selection__item", {
            "wearable-manual-selection__item--selected": isSelected,
         })}
         onClick={() => handleSelect(wearable)}
      >
         <div className="wearable-manual-selection__item-content">
            <div className="wearable-manual-selection__item-mac">
               {wearable.macAddress}
            </div>
         </div>
         {wearable.batteryPercentage != null && (
            <div className="wearable-manual-selection__item-battery">
               <Icon
                  name={getBatteryChargeIcon(wearable.batteryPercentage)}
                  color={isSelected ? IconColor.WHITE : IconColor.HONOLULU_BLUE}
                  size="16"
               />
               <span>{wearable.batteryPercentage}%</span>
            </div>
         )}
      </div>
   )

   const title = (
      <>
         Please select a ReassureBand to connect to inmate&nbsp;
         {inmateId && (
            <span className="wearable-manual-selection__inmate-id">
               {inmateId}
            </span>
         )}
      </>
   )

   return (
      <SearchAndSelect
         items={wearables}
         title={title}
         noResultsTitleTerm="wearables"
         isLoading={isLoading}
         onCancel={onCancel}
         onSave={onSave}
         filter={filterWearables}
         renderItem={renderWearable}
      />
   )
}

export default WearableManualSelection
